import {Validators} from '@angular/forms';

import {ColorCodesEnum, ComponentTypesEnum} from '../../../app/shared/enums';
import {Helper, RadioGroupControl, SelectControl} from '../../../app/shared/classes';
import {ReportTableColumn, ReportTableConfigInterface, ReportTableData} from '../../../app/shared/components';

import {PepManagerApprovalEnum} from '../../../app/entries/panel/enums';

export const PepDetailsStatusSelector = 'pepDetailsStatus';
export const PepDetailsRiskScoreSelector = 'pepDetailsRiskScore';
export const PepDetailsApprovalSelector = 'pepDetailsManagerApproval';
export const PepDetailsRiskClassificationSelector = 'pepDetailsRiskClassification';

export const PepDetailsFormArraySelector = 'pepFormArray';

export const PepDetailsControls = (): SelectControl[] => {
    return [
        new SelectControl({
            name: PepDetailsStatusSelector,
            value: null,
            placeholder: 'Status',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [
                {
                    label: 'No',
                    value: 0
                },
                {
                    label: 'Yes',
                    value: 1
                }
            ],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: PepDetailsApprovalSelector,
            value: null,
            placeholder: 'Manager approval',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [
                {
                    label: Helper.textsHelper().getPepManagerApprovalName(PepManagerApprovalEnum.None),
                    value: PepManagerApprovalEnum.None
                },
                {
                    label: Helper.textsHelper().getPepManagerApprovalName(PepManagerApprovalEnum.No),
                    value: PepManagerApprovalEnum.No
                },
                {
                    label: Helper.textsHelper().getPepManagerApprovalName(PepManagerApprovalEnum.Yes),
                    value: PepManagerApprovalEnum.Yes
                }
            ],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: PepDetailsRiskClassificationSelector,
            value: null,
            placeholder: 'Risk level',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        })
    ];
};

export const PepDetailsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: PepDetailsStatusSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: PepDetailsApprovalSelector,
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: PepDetailsRiskClassificationSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: PepDetailsRiskScoreSelector,
            value: null,
            hidden: false
        }),
    ];
};

export const PepDetailsDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Is PEP',
            selector: PepDetailsApprovalSelector
        }),
        new ReportTableColumn({
            label: 'Manager approval',
            selector: PepDetailsApprovalSelector
        }),
        new ReportTableColumn({
            label: 'Risk level',
            selector: PepDetailsRiskClassificationSelector
        }),
        new ReportTableColumn({
            label: 'Risk score',
            selector: PepDetailsRiskScoreSelector
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false,
    disableColumnsOptions: true
};

export const FinancialSanctionsControl = (): RadioGroupControl => {
    return new RadioGroupControl({
        name: PepDetailsStatusSelector,
        value: null,
        placeholder: 'Financial sanctions',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.Select,
        options: [
            {
                label: 'No',
                value: null,
                color: ColorCodesEnum.Primary
            },
            {
                label: 'Yes',
                value: null,
                color: ColorCodesEnum.Primary
            }
        ],
        floatingLabelNever: true
    });
};
